<template>
<div>
      <StartseiteMap v-if="$store.getters.fetchBetriebe.betriebe.length > 0" ref="startseiteMap" ></StartseiteMap>
      <div
        class="hidden-sm-and-down mb-0"
        absolute
        bottom
        left
        v-if="$store.state.suche.betriebe.length > 0"
      >
        <v-btn
          class="mb-0"
          dark
          color="accent"
          style="z-index: 5;"
          @click="loescheBetriebe()"
        >Zurück zur Startseite</v-btn>
        <v-btn 
          class="mb-0" 
          style="z-index: 5;" 
          @click="ScrollZuMir()"
          v-if="this.$store.getters.fetchBetriebe.standortwert[0].lat"
          >Gehe zu meiner Position</v-btn>
        <span
          class="caption"
          v-if="this.$store.getters.fetchBetriebe.standortwert[0].typ < 3"
          style="overflow: hidden;"
        >Um genauere Ergebnisse zu erhalten können Sie den weißen Marker auf Ihren Standort ziehen.</span>
      </div>
  </div>
</template>

<script>
// import axios from 'axios'
import StartseiteMap from '~/pages/StartseiteMap'
// import { mapGetters } from 'vuex'

export default {
  // metaInfo () {
  //   return {
  //     title: 'Lokale Handwerker'
  //   }
  // },
  components: {
    StartseiteMap
  },
  data: () => ({
    isLoading: false,
    busy: false,
    Stadt: null,
    search: null,
    loading: false,
    zeigekarte: false

  }),
  computed: {
    // liste_betriebe () {
    //   return this.$store.state.suche
    // }
  },
  mounted: function () {
    this.CheckObVuexLeer()
  },
  created () {
    // this.neuGEOIP();
  },

  // watch: {
  //   search (val) {
  //     if (this.leistungenleer.length > 0) return
  //     this.getLeistungen()
  //   }
  // },
  methods: {
    // validate () {
    // 	this.$validator.validate();
    // },
    CheckObVuexLeer: function () {
      if (this.$store.getters.fetchBetriebe.betriebe.length < 1) {
        this.$router.push({
          name: 'startseite'
        })
      }
    },
    toggleMap: function () {
      this.zeigekarte = true
    },
    busyswitch: function () {
      this.$emit('busy', true)
      this.busy = false
    },
    ScrollZuMir: function () {
      this.$refs.startseiteMap.scrollzumir()
    },
    ScrollNurHoch: function () {
      this.$refs.startseiteMap.ScrollNurHoch()
    },
    scrollhochmobile: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        this.$vuetify.goTo('#scrollheadline')
      }
    },
    loescheBetriebe () {
      this.$store.dispatch('loescheBetriebe')
      this.$router.push({
        name: 'startseite'
      })
    }
  }
}
</script>

<style >
</style>